export const selectFileExtension = (filename: string): null | string => {
  if (!filename.includes(".")) {
    return null;
  }

  const extension = filename.split(".").pop();

  return extension?.toLowerCase() ?? null;
};
